import { gql } from "@apollo/client";

import { organization, resourceContainer } from "./organizationFragments";

export const organizationsFragment = gql`
    fragment Organizations on MyLensesGetOrganizationsResponse {
        organizationsList {
            ...OrganizationAll
        }
    }
    ${organization.all}
`;

export const mylensesOrganizationsFragment = gql`
    fragment MyLensesOrganizations on MyLensesOrganizations {
        organizationList {
            ...ResourceContainerAll
        }
    }
    ${resourceContainer}
`;
